import React from 'react'
import StarIcon from './StarIcon'

const HighlightInfo = ({
  pertenecealacomunidadlgtbiq,
  perteneceaunpueblooriginario,
  pueblooriginariosicorresponde,
  esunapersonaensituaciondediscapacidad,
}) => {
  return (
    <div>
      {pertenecealacomunidadlgtbiq && pertenecealacomunidadlgtbiq !== 'No' && (
        <h4 className="font-bold">
          <StarIcon className="h-4 w-4 inline-block text-gray-500 mr-1" />
          #LGTBIQ+
        </h4>
      )}
      {perteneceaunpueblooriginario && perteneceaunpueblooriginario !== 'No' && (
        <h4 className=" font-bold ">
          <StarIcon className="h-4 w-4 inline-block text-gray-500 mr-1" />{' '}
          #puebloOriginario #{pueblooriginariosicorresponde}
        </h4>
      )}
      {esunapersonaensituaciondediscapacidad &&
        esunapersonaensituaciondediscapacidad !== 'No' && (
          <h4 className="">Situación de Discapacidad</h4>
        )}
    </div>
  )
}

export default HighlightInfo
